import { createContext, useContext, useEffect, useState } from "react";
import { api, ADMIN_TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!token) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem(ADMIN_TOKEN_KEY))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(ADMIN_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem(ADMIN_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const forgotPassword = async (email) => (await api.post("/auth/forgot-password", { email })).data;
  const resetPassword = async (token, password) =>
    (await api.post("/auth/reset-password", { token, password })).data;

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, forgotPassword, resetPassword, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
